var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.subscription)?_c('div',{staticClass:"subscription-licences pa-10"},[_c('v-breadcrumbs',{staticClass:"level-2",attrs:{"items":[
          {text: _vm.$tc('subscription.subscription', 2), to: {name: 'organizations.subscriptions'}, exact: true},
          {text: _vm.localizedString(_vm.subscription.subscriptionPlan.label), to: {name: 'organizations.subscriptions.edit'} },
          {text: _vm.$t('subscription.manage-licences') },
      ],"divider":">"}}),_c('subscription-licences-list',{attrs:{"subscription-id":_vm.subscription.id}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }